import React, { useState, useRef, useEffect } from 'react'
import { isIOS } from '../../utils/config'
import styles from './Report.module.css'
import {trackNew, triggerAction} from '../../utils/bridge'
interface IState {
  topMask: boolean,
  bottomMask: boolean,
}
interface IProps {
  reportContent: string,
}
export const Report: React.FC<IProps> = (props) => {
  const [topMask, setTopMask] = useState(false)
  const [bottomMask, setBottomMask] = useState(false)

  const flexContainer = useRef<HTMLDivElement>(null)
  const container = useRef<HTMLDivElement>(null)

  const { reportContent } = props

  useEffect(() => {
    setTimeout(() => {
      if (container && container.current && flexContainer && flexContainer.current) {
        if (container.current.scrollHeight > container.current.clientHeight + 10) {
          setBottomMask(true)
        }

        if (container.current.clientHeight > flexContainer.current.clientHeight) {
          container.current.style.height = `${flexContainer.current.clientHeight}px`
        }
      }
    }, 100)
  }, [])

  const handleScroll = () => {
    if (container && container.current) {
      if (container.current.scrollTop === 0) {
        setTopMask(false)
        setBottomMask(true)
      } else {
        setTopMask(true)
        setBottomMask(false)
      }
    }

  };
  let btnCls = ''
  if (!isIOS) {
    btnCls = 'btnToSeeAndroid'
  }
  return (
    <React.Fragment>
      <div className={styles.reportFlexWrap} ref={flexContainer}>
        <div
          className={styles.report}
          ref={container}
          onScroll={handleScroll}>
          <div className={styles.reportTitle}>
            <span role="img" aria-label="heart">❤️</span>
            <span>️喜欢你的人都是什么样子呢？</span>
          </div>
          <div>
            {
              reportContent.split('\\n').map(p => (<div key={p} dangerouslySetInnerHTML={{ __html: p }} />))
            }
          </div>
        </div>
        {
          topMask
          && <div className={styles.scrollMaskTop} />
        }
        {
          bottomMask && <div className={styles.scrollMaskBottom} />
        }
      </div>
      <div className={styles.btnWrap}>
        <div className={[styles.btnToSee, styles[`${btnCls}`]].join(' ')} onClick={() => triggerAction({ actionType: 'jumpToSeeOrBuySee' })}>查看谁喜欢我</div>
      </div>

    </React.Fragment>

  )
}
